enum ComponentTypes {
  CMSButton = "SchaefflerButtonComponent",
  CMSList = "SchaefflerListComponent",
  CMSParagraph = "CMSParagraphComponent",
  CMSSection = "SchaefflerMainPageComponent",
  CMSLink = "CMSLink",
  CMSColumnLink = "SchaefflerLinkComponent",
  CMSColumnLinks = "SchaefflerLinksComponent",
  CMSPageNavigation = "SchaefflerInPageNavigationComponent",
  CMSTeaserContainer = "SchaefflerTeaserContainerComponent",
  CMSTeaser = "SchaefflerTeaserComponent",
  CMSPublicationTeaser = "SchaefflerTeaserPublicationComponent",
  CMSBanner = "SchaefflerBannerComponent",
  CMSRotatingBanners = "SchaefflerRotatingBannersComponent",
  CMSStandaloneMedia = "SchaefflerStandaloneMediaComponent",
  CMSFilterableTileContainer = "SchaefflerFilterableTileContainerComponent",
  CMSLoginCall = "SchaefflerLoginCallComponent",
  CMSQuote = "SchaefflerQuoteComponent",
  CMSColumnsContainer = "SchaefflerColumnsContainerComponent",
  CMSColumn = "SchaefflerColumnComponent",
  CMSNewsLetterConsent = "SchaefflerNewsletterConsentComponent",
  CMSPhotoGallery = "SchaefflerPhotoGalleryComponent",
  CMSPhoto = "SchaefflerImageComponent",
  CMSAccordionContainer = "SchaefflerAccordionContainerComponent",
  CMSAccordion = "SchaefflerAccordionComponent",
  CMSTable = "SchaefflerTableComponent",
  EwellixPageNavigation = "SchaefflerEwellixInPageNavigationContainerComponent",
  Form = "SchaefflerForm",
  FormHiddenField = "SchaefflerFormHiddenFieldConfiguration",
  FormFieldSelect = "SchaefflerFormOptionsFieldConfiguration",
  FormFieldText = "SchaefflerFormTextFieldConfiguration",
  FormFieldCheckbox = "SchaefflerFormCheckboxFieldConfiguration",
  CMSCardComponent = "SchaefflerCardComponent",
  CMSHomepagePersonalization = "SchaefflerHomepagePersonalizationComponent",
  CMSChipLink = "SchaefflerChipsLinkComponent",
  CMSHomepagePersonalizationRecent = "SchaefflerHomepagePersonalizationRecentComponent",
  CMSChipList = "SchaefflerHomepageChipListComponent",
  CMSKameleoonSlot = "SchaefflerKameleoonSlotComponent",
  CMSIframe = "SchaefflerIframeComponent",
  CMSSimpleResponsiveBanner = "SimpleResponsiveBannerComponent",
  CMSProductCarousel = "ProductCarouselComponent",
  CMSSAPRecommendation = "CMSSAPRecommendationComponent",
  CMSImageHeader = "ImageHeaderComponent",
  CMSSimpleBanner = "SimpleBannerComponent",
  CMSRotatingImages = "RotatingImagesComponent",
  CMSImageTile = "ImageTileComponent",
  CMSImageTileContent = "ImageTileContentComponent",
  CMSForkPageNavigation = "ForkPageNavigationComponent",
  CMSCadFileSearch = "SchaefflerCADFileSearchComponent",
  CMSFccRecommendation = "SchaefflerFCCGapProductsRecommendationComponent",
  CMSHeaterSelectionAssistant = "SchaefflerHeaterSelectionAssistantComponent",
}

export default ComponentTypes;
